/*
 * Searay — product card hover zoom
 * ----------------------------------------------------------------------------
 * Hovering a product card's photo magnifies it under the cursor instead of
 * swapping to the second photo (Christina, 2026-10-02: the chains all look the
 * same at grid size, the zoom shows the link detail).
 *
 * Applies to cards showing ONE photo. A section with "Show second image on hover"
 * still on renders two and keeps Dawn's swap, so the editor setting picks one or
 * the other.
 *
 * The listener sits on the document because collection filters, sorting, the
 * size grouping and the grouped-collection loader all replace cards after load.
 * Mouse only: touch screens have no hover and keep tapping through to the product.
 */
(function () {
  'use strict';

  var ZOOM = 2.5;
  var ZOOMING_CLASS = 'searay-zoom--active';
  var MEDIA_SELECTOR = '.card-wrapper .card__media .media.media--hover-effect';
  var CARD_SELECTOR = '.card-wrapper';

  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var active = null;

  function stop() {
    if (!active) return;
    active.classList.remove(ZOOMING_CLASS);
    active = null;
  }

  // The card's grid-size srcset is too soft once magnified, so the first zoom asks
  // the browser for a candidate ZOOM times wider (the original is always in srcset).
  function sharpen(img) {
    if (img.dataset.searayZoomSized) return;
    img.dataset.searayZoomSized = '1';
    var width = img.getBoundingClientRect().width;
    if (width) img.sizes = Math.ceil(width * ZOOM) + 'px';
  }

  function onMove(event) {
    var card = event.target.closest && event.target.closest(CARD_SELECTOR);
    var media = card && card.querySelector(MEDIA_SELECTOR);
    var img = media && media.querySelector('img:only-child');
    if (!img) return stop();

    var rect = media.getBoundingClientRect();
    var x = (event.clientX - rect.left) / rect.width;
    var y = (event.clientY - rect.top) / rect.height;
    if (x < 0 || x > 1 || y < 0 || y > 1) return stop();

    if (active !== media) {
      stop();
      sharpen(img);
      active = media;
      media.style.setProperty('--searay-zoom', ZOOM);
      media.classList.add(ZOOMING_CLASS);
    }
    media.style.setProperty('--searay-zoom-x', (x * 100).toFixed(1) + '%');
    media.style.setProperty('--searay-zoom-y', (y * 100).toFixed(1) + '%');
  }

  document.addEventListener('mousemove', onMove, { passive: true });
  document.addEventListener('mouseleave', stop);
  window.addEventListener('blur', stop);
})();
